import { render } from "./AddTableModalComponent.vue?vue&type=template&id=24f24128&scoped=true"
import script from "./AddTableModalComponent.vue?vue&type=script&lang=js"
export * from "./AddTableModalComponent.vue?vue&type=script&lang=js"

import "./AddTableModalComponent.vue?vue&type=style&index=0&id=24f24128&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f24128"]])

export default __exports__